<template>

  <div>

    <v-server-table
      ref="pharmaciesTable"
      name="pharmaciesTable"
      :class="['pharmaciesTable noFirstColumn']"
      :columns="tblColumns"
      :options="table.tblOptions">

      <!-- before table: FILTER OPTIONS -->
      <template slot="beforeTable" v-if="showFilter">


        <div class="columns is-marginless filters">

          <!-- SUCHE -->
          <div class="column" v-if="showSearch">
            <div class="control has-icon search" style="min-width:150px;">
              <input class="input" type="text" v-model.trim="searchTerm" placeholder="Suchbegriff">
              <i class="fa fa-search" aria-hidden="true"></i>
            </div>
          </div>


          <!-- div class="columns filters is-pulled-right" v-if="userRole!='Kundenbetreuer'"> -->


          <!-- FILTER HAS CHANGES -->
          <div class="column is-narrow" v-if="activeFilters.indexOf('hasChanged') > -1">

            <button :class="['button filter', { 'is-blue': filters.hasChanged.value}]" @click="filters.hasChanged.value = !filters.hasChanged.value">
              mit Änderungen
              <span class="material-symbols-outlined">
                <template v-if="filters.hasChanged.value == true">toggle_on</template><template v-else>toggle_off</template>
              </span>

            </button>

          </div>

          <!-- FILTER ONLINE READY -->
          <div class="column is-narrow" v-if="can('ADVANCED.ENABLE_ONLINE_NOT_READY_SITES_FILTER') && activeFilters.indexOf('onlineReady') > -1">

            <button :class="['button filter', { 'is-blue': filters.onlineReady.value}]" @click="filters.onlineReady.value = !filters.onlineReady.value">
              bereit für online
              <span class="material-symbols-outlined">
                <template v-if="filters.onlineReady.value == true">toggle_on</template><template v-else>toggle_off</template>
              </span>

            </button>

          </div>


          <!-- FILTER PACKAGES -->
          <div class="column is-narrow" v-if="activeFilters.indexOf('packages') > -1">
            <form-input
              inputType="select"
              label="FILTER_MUTATION"
              :showLabelInOptions="true"
              :allowEmpty="true"
              :showLabel="false"
              :selectOptions="mutationOptions"
              v-model="filterPackage">
            </form-input>
          </div>

          <!-- FILTER STATUS -->
          <div class="column is-narrow" v-if="activeFilters.indexOf('status') > -1">
            <status-dropdown
              minWidth="230"
              type="siteCatalogStatus"
              label="SELECT_BOX-SITE-FILTER_STATUS-"
              :data.sync="filterStatus"
              :allowEmpty="true"
              placeholder="Status wählen"
              class="small">
            </status-dropdown>
          </div>


          <!-- FILTER: apopoint -->
          <div class="column is-narrow" v-if="activeFilters.indexOf('apopoint') > -1">

            <button :class="['button filter', { 'is-blue': filters.services.indexOf('apopoint') > -1}]" @click="setFilter('apopoint')">
              ApoPoint
              <span class="material-symbols-outlined">
                <template v-if="filters.services.indexOf('apopoint') > -1">toggle_on</template><template v-else>toggle_off</template>
              </span>

            </button>

          </div>

          <!-- FILTER: apokat -->
          <div class="column is-narrow" v-if="activeFilters.indexOf('apokat') > -1">
            <span :class="['button filter', { 'is-blue': filters.services.indexOf('apokat') > -1}]" @click="setFilter('apokat')">
              ApoKat
              <span class="material-symbols-outlined">
                <template v-if="filters.services.indexOf('apokat') > -1">toggle_on</template><template v-else>toggle_off</template>
              </span>

            </span>
          </div>


          <div class="column is-narrow" v-if="showFilter">

            <span :class="['button reset-filter', isFilterActive ? 'is-blue' : 'is-disabled']"  @click="resetFilters()" style="margin: 0 0 0 5px;">
              <span class="icon is-small">
                  <i class="icon-ak-reset"></i>
              </span>
            </span>

          </div>

        </div>

      </template>

      <!-- LOADING INDICATOR -->
      <template v-if="isLoadingTableData" slot="afterBody">

        <div class="overlay-loader">
          <loading-indicator></loading-indicator>
        </div>

      </template>

      <!-- TBL HEADER SLOTS -->
      <template slot="h__extRef" v-if="extRefColName">
        <lang :labelKey="extRefColName"></lang>
      </template>


      <!-- TBL ROW SLOTS -->

      <!-- name -->
      <template slot="name" slot-scope="props">
        {{ props.row.name }}
      </template>

      <!-- location -->
      <template slot="location" slot-scope="props">
        {{ props.row.zipcode }} {{ props.row.city }}
      </template>

      <!-- Apopoint -->
      <template slot="apopoint" slot-scope="props">
        <template v-if="props.row.apopoint == 1">
          <span class="icon is-small" style="color: #666; font-size: inherit;"><i class="fa fa-check"></i></span>
        </template>
      </template>

      <!-- Apokat -->
      <template slot="apokat" slot-scope="props">
        <template v-if="props.row.apokat == 1">
          <span class="icon is-small" style="color: #666; font-size: inherit;"><i class="fa fa-check"></i></span>
        </template>
      </template>

      <!-- ERP Status -->
      <template slot="erp" slot-scope="props">

        <div class="erpStatusWrapper" v-if="props.row.erp != null">
          <span class="erpName">{{ props.row.erp }}</span>
          <span :class="['erpStatus', props.row.erpStatus]"></span>
       </div>

      </template>

      <!-- Payment -->
      <template slot="payment" slot-scope="props">

        <template v-if="props.row.paymentProvider">
          <div class="payment-provider">{{ props.row.paymentProvider }}</div>
          <div class="payment-items" @click.stop.prevent="showPaymentPreview(props.row)" style="cursor: pointer;" title="Zahlungsarten im Detail ansehen">
            <img :src="getPaymentIcon(pmethod)" :alt="pmethod" class="payment-item" v-for="pmethod in props.row.paymentMethods.filter(pm => pm != 'nexi--MobilePay')" :title="pmethod">
          </div>
        </template>

      </template>

      <!-- SERVER Number -->
      <template slot="server" slot-scope="props">

        <template v-if="props.row.server !== null">
          <template v-if="props.row.server === 0">BETA</template>
          <template v-else>#{{ props.row.server }}</template>
        </template>

      </template>

      <!-- ApopointTyp -->
      <template slot="apoPointType" slot-scope="props">
        <lang :labelKey="props.row.apoPointTypeLabel"></lang>
      </template>

      <!-- offers Count -->
      <template slot="offersCount" slot-scope="props">
        <template v-if="props.row.apoPointType && props.row.apoPointType.name != 'WEBSITE'">
          {{ props.row.offersCount }}
        </template>
      </template>

      <!-- ORDER COUNT -->
      <template slot="orderCount" slot-scope="props">
        <template v-if="props.row.apoPointType && props.row.apoPointType.name != 'WEBSITE'">
          {{ props.row.orderCount }}
        </template>
      </template>

      <!-- ApopointDevURL -->
      <template slot="apopointDevUrl" slot-scope="props">
        <span @click.prevent.stop="openURL(props.row.apopointDevUrl)" v-if="props.row.apopointDevUrl != null">
          <span class="material-symbols-outlined">ungroup</span>
        </span>
      </template>

      <!-- ApopointURL -->
      <template slot="apopointUrl" slot-scope="props">
        <span @click.prevent.stop="openURL(props.row.apopointUrl)" v-if="props.row.apopointDevUrl != null"><span class="material-symbols-outlined">ungroup</span></span>
      </template>

      <!-- package -->
      <template slot="package" slot-scope="props">
        <div v-html="getPackage(props.row)"></div>
        <div v-if="props.row.package && props.row.package != null" class="customizationPreview" @click.stop.prevent="showCustomizationPreviews(props.row)" v-html="customizationPreviews(props.row)"></div>
      </template>

    </v-server-table>

    <modal
      :title="modal.title"
      :width="modal.width"
      :is-show="showModal"
      transition="fade"
      :backdrop-closable="false"
      @close="closeModal()"
      :class="modal.class">

        <template v-if="isCustomizationPreview">

          <div v-if="activePage != null" class="previewWrappers" :key="activePage">
            <div v-for="(value, key) in activePage.customizationPreviews" :class="[key, 'previewWrapper lazy-img-fadein']" v-lazy:background-image="loadCustomizationImage(value)" :key="key">
              <div class="title"><lang :labelKey="'SITE-MODAL-MUTATIONS_TITLE-'+key"></lang></div>
            </div>
          </div>

          <div slot="footer">
            <a class="button" @click="closeModal">{{ this.modal.txtCancel }}</a>
          </div>

        </template>

        <template v-if="isPaymentPreview">

          <div v-if="activePage != null" class="paymentPreviewWrappers">
            <template v-if="activePage.paymentProvider">
              <h3 class="title is-5" style="margin-bottom: 20px; text-align: center;">{{ activePage.paymentProvider }}</h3>
              <div class="payment-preview-items" style="display: flex; flex-wrap: wrap; gap: 8px; justify-content: center;">
                <img :src="getPaymentIcon(pmethod)" :alt="pmethod" class="payment-preview-item" style="width: 75px;" v-for="pmethod in activePage.paymentMethods.filter(pm => pm != 'nexi--MobilePay')" :title="pmethod">
              </div>
            </template>
          </div>

          <div slot="footer">
            <a class="button" @click="closeModal">{{ this.modal.txtCancel }}</a>
          </div>

        </template>

    </modal>
  </div>

</template>




<script>
import Vue from 'vue';
import { ServerTable, Event} from 'vue-tables-2';
Vue.use(ServerTable, {}, false, 'bulma');
import statusDropdown from './incl-statusDropdown'
import { debounce } from "debounce";

export default {

  name: 'pharmacies',

	components: {
    statusDropdown

	},

  props: {

    apiURL: {
      type: String,
      default: 'pimProduct/query',
      required: true
    },
    routeDetailName: {
      type: String,
      required: true
    },
    showFilter: {
      type: Boolean,
      default: true
    },
    showSearch: {
      type: Boolean,
      default: true
    },
    activeFilters: {
      type: Array,
      defeault: () => []
    },
    extRefColName: {
      type: String,
      default: null
    },
    tblColumns: {
      type: Array,
      default: () => ['extRef', 'name']
    },
    tblSortColumns: {
      type: Array,
      default: () => ['extRef', 'name']
    },
    tblOptions: {
      type: Object,
      default(rawProps) {
        return {
          perPage: 20
        }
      }
    }

  },

	data() {

    var self = this;

		return {
      timeout: null,

      isLoadingTableData: false,
      isCustomizationPreview: false,
      isPaymentPreview: false,
      activePage: null,

      showModal: false,
      modal: {
        title: "",
        width: 520,
        txtCancel: 'abbrechen',
        txtSubmit: 'senden',
        count: null,
        isSending: false,
        class: ""
      },

      searchTerm: "",

      filters: {
        search: {
          isActive: true,
          value: null
        },
        onlineReady: {
          isActive: true,
          value: null
        },
        hasChanged: {
          isActive: true,
          value: null
        },
        vouchers: {
          isActive: true,
          value: null
        },
        status: [],
        package: [],
        services: [],
      },

      table: {

        // tblColumns: ['select', 'image', 'extRef', 'name', 'categoryPath', 'price', 'packagingSize', 'manufacturerName', 'group_id', 'delete'],
        tblOptions: {

          requestFunction(data) {


            if(data.orderBy == 'location') {
              data.orderBy = 'zipcode';
            }

            data.filters = {};

            if(data.query != "" && data.query != null) {

              let query = JSON.parse(data.query);
              data.query = "";

              for(let key in query) {

                let filter = query[key];

                // if value is false for these properties, do not add them to payload
                if(key == 'hasChanged' || key == 'onlineReady') {
                  if(filter.value == false) {
                    continue;
                  }
                }

                if(Array.isArray(query[key]) && query[key].length > 0) {
                  data.filters[key] = query[key];
                }

                if(filter.isActive && filter.value != null) {

                  if(filter.type == 'select') {

                    data.filters[key] = filter.value.id;

                  } else {

                    if(key == "search") {
                      data.query = filter.value;
                    } else {
                      data.filters[key] = filter.value;
                    }

                  }

                }

              }
            }

            return this.axios.post(this.$config.api + self.apiURL, data )
                .then(response => {
                    // return response.data;
                    response.data.data.forEach((d) => {

                      if(d.apoPointType) {
                        let type = self.apopointTypes.find((type) => type.id == d.apoPointType);
                        if(type) {
                          d.apoPointType = type;
                          d.apoPointTypeLabel = 'APOPOINT-TYPE-'+type.name;
                          // d.apoPointTypeLabel = 'APOPOINT-TYPE-'+self.apopointTypes.find((type) => type.id == d.apoPointType).name;
                        }
                      }
                    })
                    return response.data;

                }).catch(function (e) {
                    console.log("error ... :", e.message);
                }.bind(this))

          },

          uniqueKey: 'id',
          perPage: 10,
          /*
          orderBy: {
              ascending: false,
              column: 'updated_at'
          },
          */
          sortIcon: {
            base:'fa',
            up:'fa-sort-up',
            down:'fa-sort-down',
            is:'fa-sort'
          },
          saveState: false,
          preserveState: false,
          filterable: true,
          headings: {
            extRef(h) {
              return <lang labelKey="PHARMACY-TABLE_HEADING-EXTREF"></lang>
            },
            name(h) {
              return <lang labelKey="PHARMACY-TABLE_HEADING-NAME"></lang>
            },
            /*
            categoryPath(h) {
              return <lang labelKey="PIM-TABLE_HEADING-CATEGORY_PAT"></lang>
            },
            price(h) {
              return <lang labelKey="PIM-TABLE_HEADING-PRICE"></lang>
            },
            packagingSize(h) {
              return <lang labelKey="PIM-TABLE_HEADING-PACKAGING_SIZE"></lang>
            },
            packagingSize(h) {
              return <lang labelKey="PIM-TABLE_HEADING-PACKAGING_SIZE"></lang>
            },
            manufacturerName(h) {
              return <lang labelKey="PIM-TABLE_HEADING-MANUFACTURER"></lang>
            },
            */
            location(h) {
              return <lang labelKey="PHARMACY-TABLE_HEADING-LOCATION"></lang>
            },
            apoPointType(h) {
              return <lang labelKey="PHARMACY-TABLE_HEADING-APOPOINT_TYPE"></lang>
            },
            orderCount(h) {
              return <lang labelKey="PHARMACY-TABLE_HEADING-ORDERS_COUNT"></lang>
            },
            payment(h) {
              return <lang labelKey="PHARMACY-TABLE_HEADING-PAYMENT"></lang>
            },
            offersCount(h) {
              return <lang labelKey="PHARMACY-TABLE_HEADING-OFFERS_COUNT"></lang>
            },
            apopointUrl(h) {
              return <lang labelKey="PHARMACY-TABLE_HEADING-APOPOINT_URL"></lang>
            },
            apopointDevUrl(h) {
              return <lang labelKey="PHARMACY-TABLE_HEADING-APOPOINT_DEV_URL"></lang>
            },
            package(h) {
  						return <lang labelKey="SITE_TBL_HEADER-PACKAGE"></lang>
  					},
  					quantity(h) {
  						return <lang labelKey="SITE_TBL_HEADER-QTY"></lang>
  					},
  					postDelivery(h) {
  						return <div><lang labelKey="SITE_TBL_HEADER-POST_DELIVERY"></lang><br /><span class="is-small">Datei/PLZ</span></div>
  					},
  					coupons(h) {
  						return <lang labelKey="SITE_TBL_HEADER-COUPONS"></lang>
  					},
          },
          // sortable: ['extRef', 'name', 'categoryPath', 'price', 'packagingSize', 'manufacturerName'],
          sortable: this.tblSortColumns,
          texts: {
            first:'Anfang',
            last:'Ende',
            filter: 'Filter Ergebnisse:',
            filterPlaceholder: 'Suche',
            limit: 'Einträge pro Seite',
            noResults: 'keine passenden Einträge gefunden',
            count: '{from} bis {to} von {count} Einträgen|{count} Einträge|ein Eintrag',
            loading: 'Lade Daten ...'
          },
          pagination: {
            dropdown: false,
            chunk: 4,
            edge: false
          },

          // initialPage: self.$store.getters.getCurrentpharmaciesTablePage || 1,
          skin: 'table is-striped is-hoverable is-fullwidth',

          // customizations for table columns
  				templates: {

  					city: function(h, row) {
              return row.site.zipcode + ' ' + row.site.city;
  					},

  					quantity: function(h, row) {
  						return row.quantity != 0
  							? row.quantity + '+' + row.rebateInKind + '=' + (parseInt(row.quantity) + parseInt(row.rebateInKind))
  							: '';
  					},

  					postDelivery: function(h, row) {

  						if(row.shipmentRecipientListQty > 0 || row.shipmentAreaQty > 0)
  						{
  							return (row.shipmentRecipientListQty != null && row.shipmentRecipientListQty != "" ? row.shipmentRecipientListQty : '-') + " / " + (row.shipmentAreaQty != null && row.shipmentAreaQty != "" ? row.shipmentAreaQty : '-');
  						}
  						else
  						{
  							return "";
  						}
  					},

  					coupons: function(h, row) {
  						if(
  							(row.promotionMaterialPackageQty != 0 && row.promotionMaterialPackageQty != null) ||
  							(row.couponBoxQty != 0 && row.couponBoxQty != null) ||
  							(row.couponSetQty != 0 && row.couponSetQty != null)
                            ) {
  					 		return (row.promotionMaterialPackageQty != 0 ? row.promotionMaterialPackageQty : '-') + ' / ' + (row.couponBoxQty != null ? row.couponBoxQty : '-') + ' / ' + (row.couponSetQty != 0 ? row.couponSetQty : '-');
  						}
  					}

          },
          columnsClasses: {
            'apopoint': 'apopoint',
            'apokat': 'apokat',

            'extRef': 'pzn',
            'name': 'name',
            'packagingSize': 'packagingSize',
            'price': 'price',
            'image': 'thumbnail',
            'group_id': 'variable',
            'actions': 'actions',
            'apopointDevUrl': 'apopointDevURL',
            'apopointUrl': 'apopointURL',
            'payment': 'payment'
          },

          rowClassCallback: function(row) {
            /*
            if(self.preselectedProducts.length == 0) {
                return;
            }
            return self.preselectedProducts.indexOf(parseInt(row.id)) != -1 ? 'is-disabled' : '';
            */
          }

        }
      },
    }

  },

  computed: {

    mutationOptions() {

      return [
        /*
        {
            name: this.$t("ALL"),
            value: 'all'
        },
        */
        {
            name: this.$t("U1_U4"),
            value: 1
        },
        {
            name: this.$t("U1_U4-GS"),
            value: "1GS"
        },
        {
            name: this.$t("U1_U4_U2"),
            value: 2
        },
        {
            name: this.$t("U1_U4_U2-GS"),
            value: "2GS"
        },
        {
            name: this.$t("U1_U4_U2_US"),
            value: 3
        },
        {
            name: this.$t("U1_U4_U2_US-GS"),
            value: "3GS"
        },
        {
            name: this.$t("CUSTOM_DESIGN"),
            value: 4
        },
        {
            name: this.$t("CUSTOM_DESIGN-GS"),
            value: "4GS"
        },

      ]

    },

    apopointTypes() {
      return this.$store.getters.getTermsByTaxonomyRaw('APOPOINT_TYPES');
    },

    voucherPackages() {
      return this.$store.getters.getTermsByTaxonomy('VOUCHER_PACKAGES');
    },

    voucherStatus() {
      return this.$store.getters.getTermsByTaxonomy('VOUCHER_STATUS');
    },

    debouncedSearch: {
       get() {
         return this.filters.search.value;
       },
       set(val) {
         if (this.timeout) clearTimeout(this.timeout)
         this.timeout = setTimeout(() => {
           this.filters.search.value = val
         }, 800)
       }
    },

    filterPackage: {

      get() {
        //  return this.$store.getters.getPharmaciesFilter('filterStatus');
        if(this.filters.package.length == 0) {
          return null;
        }

        let checkPackage = this.filters.vouchers.value == true
          ? this.filters.package[0].toString() + 'GS'
          : this.filters.package[0].toString();

        return this.mutationOptions.filter((mutation) => mutation.value == checkPackage);

      },

      set(val) {

        this.filters.package = [];

        if(val) {
          let value = val.value;
          let newVal = "";

          if(!Number(value) && value.includes('GS')) {
            newVal = Number(value.substring(0, 1));
            this.filters.vouchers.value = true;
          } else {
            newVal = value;
            this.filters.vouchers.value = false;
            this.filters.vouchers.value = null;
          }
          this.filters.package.push(Number(newVal));
        }
        // if val==null (filter is deselected), also set vouchers.value to null
        else {
          this.filters.vouchers.value = null;
        }

      }


    },

    filterStatus: {

      get() {
        return this.siteCatalogStatus.filter((status) => status.id == this.filters.status)[0];
      },

      set(val) {

        this.filters.status = [];
        if(val) {
          this.filters.status.push(val.id);
        }

      }

    },



    isFilterActive() {

      for(let key in this.filters) {

        if(Array.isArray(this.filters[key]) && this.filters[key].length > 0) {
          return true;
        }

        if(key == 'search' && this.filters[key].value != null && this.filters[key].value != '') {
          return true;
        }

        if(this.filters[key].value && this.filters[key].value != false) {
          return true;
        }



      }
    },

    siteCatalogStatus() {
      return this.$store.getters.getTermsByTaxonomyRaw('SITE_CATALOG_STATUS');
    },

  },

  watch: {

    searchTerm() {
      this.performSearch();
    },

    "filters": {
      handler(newValue, oldValue) {
        this.filter();
      },
      deep: true
    }

  },

  created() {

    // merge with given tblOptions props
    this.table.tblOptions = {
      ... this.table.tblOptions,
      ... this.tblOptions
    }

  },


  mounted() {

    Event.$on('vue-tables.pharmaciesTable.loading', (data) => {
        this.isLoadingTableData = true;
        this.$emit('dataLoaded', false);
    });

    Event.$on('vue-tables.pharmaciesTable.loaded', (data) => {
        this.isLoadingTableData = false;
        this.$emit('dataLoaded', true);
    });

    Event.$on('vue-tables.pharmaciesTable.row-click', this.onRowClickHandler);

  },

  beforeDestroy() {
    Event.$off('vue-tables.pharmaciesTable.row-click', this.onRowClickHandler);
  },

  methods: {

    performSearch: debounce(async function () {

      if (this.searchTerm === "" ||this.searchTerm.length < 2) {
        return;
      }

      this.filters.search.value = this.searchTerm; // this.filter() will be automatically triggered by a watcher
    }, 500),

    openURL(url) {
      if(!url) return false;
      window.open(url, "_blank");
    },

    closeModal() {

      this.showModal = false;
      this.modal.isSending = false;
      this.modal.class = null;
      this.isCustomizationPreview = false;
      this.isPaymentPreview = false;
      this.activePage = null;

    },
    setFilter(type) {

      let foundIndex = this.filters.services.indexOf(type);

      if(foundIndex > -1) {
        this.filters.services.splice(foundIndex, 1);
      } else {
        this.filters.services.push(type);

      }

    },

    onRowClickHandler(row) {

      if(['apopointURL', 'apopointDevURL', 'button', 'icon'].indexOf(row.event.target.className) > -1) {
          return false;
      }

      this.$router.push({ name: this.routeDetailName, params: { siteID: row.row.id }})
    },

    resetFilters() {

      this.searchTerm = "";

      for(let key in this.filters) {

        if(Array.isArray(this.filters[key])) {
          this.filters[key] = [];
        } else {
          this.filters[key].value = null;
        }
      }
      this.filter();
    },

		getImagePath(asset, thumb=false) {
			return this.$config.assets + asset.path + '/' + (thumb != false ? 'thumb/' : '') + asset.filename;
		},

    filter() {
      let query = "";
      // this.$store.commit('setPIMFilter', this.filters)
      this.$refs.pharmaciesTable.setFilter(JSON.stringify(this.filters));
    },

    getPackage(row) {

      if(row.package && row.package != null) {

        var mutation = " - ";

        // get language string for packge id
        switch(parseInt(row.package)) {
            case 1:
                mutation = "Paket 1";
                break;
            case 2:
                mutation = "Paket 2";
                break;
            case 3:
                mutation = "Paket 3";
                break;
            default:
                mutation = row.package;
        }


        // check if there are any voucherPackages
        if(row.voucherPackage) {

            // voucher package 3
            if(row.voucherPackage == this.voucherPackages.VOUCHERS_3.id) {
                mutation += " + GS";
            }

            // voucher package 6
            else if(row.voucherPackage == this.voucherPackages.VOUCHERS_6.id) {
                mutation += " + GS(6)";
            }

            else {
                mutation += "";
            }

        }

        return mutation;


      } else {

          return "";

      }

    },

    customizationPreviews(row) {

        var res = "";
        if(row.customizationPreviews) {

            for (var property in row.customizationPreviews) {
                if (row.customizationPreviews.hasOwnProperty(property)) {
                    let iconClass = "icon-ak-check-";
                    iconClass += row.customizationPreviews[property] != null ? 'active' : 'empty';
                    res += '<span class="icon is-small"><i class="'+iconClass+'"></i></span>';
                }
            }

            /*
            for(let i =0; i < parseInt(row.package); i++) {

                let iconClass = "icon-ak-check-";
                if(i==0 && row.customizationPreviews.U1_U4 != null ||
                    i==1 && row.customizationPreviews.U2 != null ||
                    i==2 && row.customizationPreviews.US != null) {
                    iconClass += 'active';
                } else {
                    iconClass += 'empty';
                }

                res += '<span class="icon is-small"><i class="'+iconClass+'"></i></span>';

            }
            */

        }

        return res;
    },

    showCustomizationPreviews(row) {

      this.isCustomizationPreview = true;
      this.activePage = row;
      this.modal.title = row.name + ' (#'+row.extRef+')';
      this.modal.txtCancel = "schließen";
      this.modal.type = null;
      this.modal.class = "fullPage";
      this.showModal = true;

    },

    showPaymentPreview(row) {

      this.isPaymentPreview = true;
      this.activePage = row;
      this.modal.title = 'Zahlungsarten im Detail';
      this.modal.txtCancel = "schließen";
      this.modal.type = null;
      this.modal.class = "";
      this.showModal = true;

    },

    loadCustomizationImage(img) {
      return this.$config.assets + img;
    },

    getPaymentIcon(method) {

        if (!method) return null;

        let icon = null;

        switch (method) {
          case 'bacs':

            icon = 'payment-vorauskasse.png';
            break;

          case 'cheque':

            icon = 'payment-rechnung.png';
            break;

          case 'cash_on_delivery':
          case 'cod':

            icon = 'payment-bar.png';
            break;

          case 'mollie_wc_gateway_banktransfer':
          case 'german_market_sepa_direct_debit':

            icon = 'payment-sepa.png';
            break;

          case 'eps':
          case 'ViveumCw_Eps':
          case 'mollie_wc_gateway_eps':
          case 'qenta_checkout_page--eps':

            icon = 'payment-eps.png';
            break;

          case 'paypal':
          case 'nexi--PayPal':
          case 'ViveumCw_PayPal':
          case 'mollie_wc_gateway_paypal':
          case 'TeleCashCw_PayPal':
          case 'qenta_checkout_page--paypal':

            icon = 'payment-paypal.png';
            break;

          case 'nexi--Visa':
          case 'ViveumCw_Visa':
          case 'TeleCashCw_Visa':

            icon = 'payment-visa.png';
            break;

          case 'nexi--MasterCard':
          case 'ViveumCw_MasterCard':
          case 'TeleCashCw_MasterCard':

            icon = 'payment-mastercard.png';
            break;

          case 'ViveumCw_AmericanExpress':

            icon = 'payment-amex.png';
            break;

          case 'ViveumCw_DinersClub':
 
            icon = 'payment-dinersclub.png';
            break;

          case 'ViveumCw_Maestro':

            icon = 'payment-maestro.png';
            break;

          case 'nexi--Klarna':
          case 'mollie_wc_gateway_klarna':
            icon = 'payment-klarna.png';
            break;

          case 'nexi--ApplePay':
          case 'mollie_wc_gateway_applepay':
            icon = 'payment-applepay.png';
            break;

          case 'mollie_wc_gateway_creditcard':
          case 'qenta_checkout_page--ccard':
      
            icon = 'payment-kreditkarte.png';
            break;

          case 'nexi--Sofort':
          case 'ViveumCw_DirectEBanking':
          case 'mollie_wc_gateway_sofort':
          case 'mollie_wc_gateway_paybybank':
          case 'qenta_checkout_page--sofortueberweisung':
            icon = 'payment-sofort.png';
            break;

          case 'nexi--GooglePay':
            icon = 'payment-googlepay.png';
            break;

          case 'nexi--VisaClickToPay':
            icon = 'payment-visaclicktopay.png';
            break;
        }

        return `/payment-icons/${icon}`;
    }
  }

}
</script>


<style lang="scss" scoped>

  td .material-symbols-outlined {
    font-size: 14px;
  }

  .p-default {
    margin: 0;
  }

  .pharmaciesTable {

    ::v-deep table.VueTables__table {
      position: relative;
    }

    .imgWrapper {
        background-repeat: no-repeat;
        background-position: 50% 50%;
        background-size: contain;
        width: 80px;
        height: 60px;
        margin: 0;
        background-color: #FFF;
        border: 1px solid #efefef;
        border-radius: 2px;
    }
    .imgWrapper[lazy=loading]  {
        background-size: 30% !important;
    }
    .imgWrapper[lazy=error]  {
        background-image: none !important;
    }

    .erpStatusWrapper {
      display: flex;
      align-items: center;
      gap: 5px;
      .erpName {
        text-transform: uppercase;
        color: #999;
        line-height: 1;
      }
      .erpStatus {
        margin:0;
        display: inline-block;
        width: 10px;
        height: 10px;
        background-color: #D5D5D5;
        border-radius: 50%;
        &.SUCCESS {
          background-color: #6cc788;
        }
        &.WARNING {
          background-color: orange;
        }
        &.ERROR {
          background-color: #ed6060;
        }
      }

    }

  }

  ::v-deep .VueTables {

    #VueTables_th--apokat,
    #VueTables_th--apopoint {
      width: 90px;
      max-width: 90px;
    }
    #VueTables_th--apopointDevUrl,
    #VueTables_th--apopointUrl {
      width: 85px;
      max-width: 85px;
    }
    .button {
      font-size: 12px;
      .material-symbols-outlined {
        font-size: 24px;
        margin-left: 4px;
      }

    }

    td.actions {
      text-align: right;
      .button {
        .icon {
            margin: 0 !important;
            font-size: 12px;
        }
      }
    }
    td.payment {
      white-space: normal;
      text-overflow: clip;
      .payment-provider {
        margin-bottom: 4px;
        /*font-weight: bold;*/
      }
      .payment-items {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        gap: 3px;
        .payment-item {
          display: inline-block;
          width: 32px;
        }
      }
    }
  }

  .pharmacySelector {

    padding: 15px;
    display: flex;
    flex-direction: column;

    .pharmacySelectorLabel {
      font-size: 10px;
      text-transform: uppercase;
      padding-bottom: 4px;
    }

    > div {
      margin: 0;
      width: 100%;
      ::v-deep .control {
          margin-bottom: 0;
          max-width: 100% !important;
      }

      &:not(:last-child) {
          margin-right: 5px;
      }
    }

    .button {
      font-size: 11px;
      text-transform: uppercase;
      line-height: inherit;
      display: flex;
      align-items: center;
      justify-content: center;
    }

  }

</style>

<style scoped>

  .inputName {
    margin: 0;
    padding: 0;
    height: auto;
    line-height: inherit;
    font-size: 12px;
    background: none;
    border: 0;
    transition: all .3s ease;
    cursor: pointer;
  }

  .inputName:not(:focus) {
    white-space: nowrap;
  	overflow: hidden;
  	text-overflow: ellipsis;
  }

  .inputName:focus {
    padding: 8px;
    background: #eaeaea;
  }

  ::v-deep .pharmaciesTable .VueTables__search {
    display: none;
  }
  ::v-deep .pharmaciesTable .VueTables__table {
    position: relative !important;
  }
  ::v-deep .pharmaciesTable .VueTables__table tr.is-disabled {
    opacity: 0.3;
  }
  ::v-deep .pharmaciesTable .VueTables__table td {
    position: relative !important;
  }

  .overlay-loader {
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: white;
    opacity: 0.8;
  }



  ::v-deep .v-spinner.small {
		height: auto !important;
		max-width: 250px;
        margin: 0;
	}
	::v-deep .v-spinner.small .v-clip {
		height: 12px !important;
		width: 12px !important;
	}

  ::v-deep .customWarning {
    font-size: 12px;
    padding-top: 0;
    padding-bottom: 0;
    background-color: transparent !important;
    color: #666 !important;
  }
  ::v-deep .customWarning .wrap-icon {
    margin-top: -9px;
  }
  ::v-deep .customWarning .wrap-icon i {
    font-size: 16px;
    color: #666;
  }
</style>
